module.exports = __webpack_public_path__ + "static/media/RobertaZ.9d6d8fd8.jpg";